import type { SignInProvider } from '@shefira/shared';

import { uiText } from './text.js';

/**
 * A sign-in or link button: the service's logo alone (`data/assets/src/ui/icon-<provider>.png`),
 * its label in the tooltip and for screen readers, like the HUD's buttons.
 */
export function providerButton(provider: SignInProvider, label: string, className: string): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `${className} provider-button`;
  button.title = uiText(label);
  button.setAttribute('aria-label', uiText(label));
  const image = document.createElement('span');
  image.className = 'provider-button__icon';
  image.style.backgroundImage = `url('/assets/ui/icon-${provider}.png')`;
  image.setAttribute('aria-hidden', 'true');
  button.append(image);
  return button;
}
